module.exports = __webpack_public_path__ + "static/media/8OLA26.c0696d18.jpg";